module.exports = __webpack_public_path__ + "img/fleet management.afd3ec1b.svg";